<template>
  <div>
    <div class="darkbg" v-if="darkBg"></div>
    <div :class="(customerClass ? 'block alertdialog ' + customerClass : 'block alertdialog')">
      <div style="text-align:right;">
        <img src="/images/icon_close.png" style="width: 19px; height: 19px; object-fit: cover;" @click="closeWin(0)">
      </div>
      <div class="row childcenter" v-if="!showInfoLink">
        <div class="picture">
          <img :src="'/images/' + (img != '' ? img : (needConfirm ? 'icon_suc.png' : 'icon_suc.png'))" class="bg" />
        </div>
      </div>
      <div class="row h childcenter title" v-if="title" style="justify-content: center;">{{ title }}</div>
      <div class="row h childcenter" v-if="customerName"
        style="margin:1.5rem 0.1rem; font-size:2rem; font-weight:bolder;justify-content: center;">{{ customerName }}
      </div>
      <div class="row content childcenter" v-if="ishtml(content)" v-html="content"></div>
      <div class="row content childcenter" v-else style="">
        {{ content }}
      </div>
      <div class="row childcenter btn" :class="{ 'btn-without-content': !content }">


        <div :class="'button' + (needConfirm ? ' btn-cancel' : '')" @click="closeWin(1)"
          :style="btnsetting.style ? btnsetting.style : { background: btnsetting.bg, color: btnsetting.color }">
          {{ needConfirm ? cancelBtnTxt : (btnsetting.txt) }}
          <span class='button_desc' v-if="button1Desc != ''">
            {{ button1Desc }}
          </span>
        </div>
        <div class="button btn-box" v-if="needConfirm" @click="confirm"
          :style="{ background: confirmBtnSetting.bg, color: confirmBtnSetting.color, border: confirmBtnSetting.bor }">
          {{ confirmBtnTxt }}</div>
      </div>
      <div class="info-link" v-if="showInfoLink">
        <div class="tooltip-container">
          <span @click="handleInfoClick">
            {{ infoLinkText }}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; vertical-align: middle; margin-left: 4px;">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <path d="M8 7V11M8 5V5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
          <div class="tooltip-content" v-if="showTooltip">
            {{ tooltipContent }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- -->
</template>
<script>
import '@/assets/main.css'
import { useI18n } from 'vue-i18n';
export default {
  emits: ['closeWin'],
  components: {},
  props: {
    darkBg: {
      type: Boolean,
      default: true,
    },
    status: {
      type: [String],
      default: 'success' //fail
    },
    title: {
      type: [String],
      default: ''
    },
    customerName: {
      type: [String],
      default: ''
    },
    content: {
      type: [String],
      default: ''
    },
    pagereload: {
      type: Boolean,
      default: false,
    },
    needConfirm: {
      type: Boolean,
      default: false,
    },
    img: {
      type: [String],
      default: ''
    },
    cancelBtnTxt: {
      type: [String],
      default: ''
    },

    button1Desc: {
      type: [String],
      default: ''
    },
    confirmBtnTxt: {
      type: [String],
      default: ''
    },

    btnsetting: {
      type: Object,
      default: {
        txt: '',
        bg: '#00F1BD',
        color: '#000000',

      }
    },
    confirmBtnSetting: {
      type: Object,
      default: {
        txt: '',
        bor: '1px solid #57855f',
        bg: '#57855f',
        color: '#000000'
      }
    },

    customerClass: {
      type: [String],
      default: ''
    },
    showInfoLink: {
      type: Boolean,
      default: false
    },
    infoLinkText: {
      type: [String],
      default: 'More information'
    },
  },
  data() {
    return {
      showTooltip: false,
      tooltipContent: 'TripToGo offers a selection of airlines and airfares for your convenience. For instant purchase airfare, full airfare payment is due at the time of booking. Your ticket confirmation will be sent within 24 to 72 business hours after it has been issued.'
    }
  },
    setup(props) {
      const { t } = useI18n();
    const cancelBtnTxt = props.cancelBtnTxt || t("common.close");
    const confirmBtnTxt = props.confirmBtnTxt || t("common.confirm");

    const btnsetting = {
      ...props.btnsetting,
      txt: props.btnsetting.txt || t("common.closeWindow"),
    };

    const confirmBtnSetting = {
      ...props.confirmBtnSetting,
      txt: props.confirmBtnSetting.txt || t("common.confirm"),
    };

    return {
      t,
      cancelBtnTxt,
      confirmBtnTxt,
      btnsetting,
      confirmBtnSetting,
    };
  },
  created() { },
  methods: {
    ishtml(str) {
      return typeof str === 'string' && /<\/?[a-z][\s\S]*>/i.test(str);
    },
    closeWin(t) {
      let param = this.pagereload ? { pagereload: true } : {};
      if (t <= 0) {
        param = { ...param, close: true };
      }
      this.$emit('closeWin', param);
    },
    confirm() {
      this.$emit('closeWin', { confirm: true })
    },
    handleInfoClick() {
      // Toggle tooltip display
      this.showTooltip = !this.showTooltip;
    }
  }
}
</script>



<style lang="scss" scoped>
/*   .button_title
  {
    display: inline-block;
    line-height:2rem;
  
  } */
.button_desc {
  font-size: 1.3rem;
  font-weight: normal;
  display: block;
  line-height: 1.3rem;
  padding: 0.5rem;
  padding-top: 0;
}

.alertdialog {
  text-align: center;
  color: #333;
  width: 568px;
  top: 50%;
  left: 50%;
  padding: 55px;
  padding-top: 15px;
  padding-right: 25px;
  transform: translate(-50%, -50%);
}

.alertdialog .picture {
  width: 10rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 4rem;
  border: 0;
  border-radius: 0;
}

.alertdialog .picture img {
  width: 100%
}

.alertdialog .childcenter {
  font-family: Poppins;
  font-size: 17px;
  font-weight: 700;
  line-height: 30px;
  padding: 0;
  flex-wrap: wrap;
}

.alertdialog .content {
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 3rem;
  margin: 1.7rem 0 3rem;
}

.alertdialog.refund-confirm-dialog .content {
  margin: 1.2rem 0 3rem;
  max-width: 43rem;
  margin-left: auto;
  margin-right: auto;
  color: #1f2937;
  font-size: 1.5rem;
  line-height: 2.8rem;
  font-weight: 400;
}

.alertdialog.refund-confirm-dialog .content :deep(.refund-confirm-copy) {
  margin: 0;
}

.alertdialog.refund-confirm-dialog .content :deep(.refund-confirm-copy + .refund-confirm-copy) {
  margin-top: 0.4rem;
}

.alertdialog.refund-confirm-dialog .content :deep(.refund-confirm-wallet-wrap) {
  display: inline;
  font-weight: 500;
}

.alertdialog.refund-confirm-dialog .content :deep(.refund-confirm-wallet-link) {
  display: inline;
  margin-left: 0.3rem;
  color: #19aef5;
  font-weight: 700;
  text-decoration: none;
}

.alertdialog.refund-confirm-dialog .content :deep(.refund-confirm-wallet-link:hover) {
  text-decoration: underline;
}

.alertdialog .btn .button {
  font-family: Poppins;
  font-size: 1.7rem;
  font-weight: 700;

  height: auto;
  min-height: 4.4rem;
  border-radius: 0.8rem;
  width: 100%;
  margin-top: 0;
}

.alertdialog .btn-without-content {
  margin-top: 2.6rem;
}

.alertdialog .btn .btn-box {
  // width: 45%;
  margin: 10px 10px 0 10px;
}

.alertdialog .btn .btn-cancel {
  // width: 45%;
  margin: 0 10px;
  background: #2dcde9;
}

.h {
  font-size: 3rem !important;
}
.customWin{
  width:650px;
}

.info-link {
  margin-top: 2rem;
  text-align: left;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  color: #666;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.info-link span {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s ease;
}

.info-link span:hover {
  color: #333;
  text-decoration: underline;
}

.tooltip-content {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 1rem;
  padding: 1.5rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 400px;
  max-width: 90vw;
  font-size: 1.3rem;
  line-height: 2rem;
  color: #333;
  text-align: left;
  z-index: 1000;
}

.tooltip-content::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 2rem;
  border: 8px solid transparent;
  border-top-color: white;
}

@media screen and (max-width: 750px) {
  .alertdialog {
    width: 90%;
    padding: 20px;
  }

  .h {
    font-size: 2rem !important;
  }

  .alertdialog .picture {

    margin: 1.5rem auto;

    width: 6rem;
    height: 6rem;
  margin-bottom:3rem;
  margin-top:0rem;
    

  }


  .alertdialog .childcenter {
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 2rem;

  }

  .alertdialog .content {
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 2rem;
    margin-top: 1.3rem;
  }

  .alertdialog.refund-confirm-dialog .content {
    max-width: none;
    font-size: 1.2rem;
    line-height: 2.2rem;
    margin: 1.1rem 0 2.4rem;
  }

  .alertdialog.refund-confirm-dialog .content :deep(.refund-confirm-copy + .refund-confirm-copy) {
    margin-top: 0.3rem;
  }


  .alertdialog .btn .btn-box {

    margin: 1.5rem 0px;
  }

  .alertdialog .btn .button {

    font-size: 1.5rem;

    min-height: 3.2rem;
    width: 90%;



  }

  .info-link {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    line-height: 1.8rem;
  }

  .tooltip-content {
    width: 300px;
    font-size: 1.2rem;
    line-height: 1.8rem;
    padding: 1.2rem;
  }

}
</style>
